import React from "react";
import ChrTooltip from "../../../Form/Basic/ChrTooltip";
import ChrBadge from "../ChrBadge";
import { metricType } from "../../constants.js";
import { getHoverOptions } from "../../../Utils/commonUtils.js";
import ChrInfoPopover from "../../../Form/Basic/ChrInfoPopover.jsx";

/*
props = {
  children: <string | component>,
  helpText: <string>,
  type: <'metric' | 'submetric'>,
  badges: [<Hash for ChrBadge>,...]
}
*/

const ChrMetricTitle = (props) => {
  const type = props.type || metricType.METRIC;
  let className = 'p-1 whitespace-nowrap truncate-with-ellipsis';
  const titleHoverContent = props.hoverContent || ((typeof props.children === 'string') ? props.children : "");

  if (type == metricType.SUBMETRIC)
    className += ' text-muted cui-management-report-temp-sub-metric-title';
  else if (type === metricType.METRIC)
    className += ' cui-management-report-temp-metric-title';

  // Passing container here to get font color and sizes for management report v2. This can be removed after global font and color change
  const infoComponent = props.forceTooltip ? <ChrTooltip content={ props.helpText } className="text-info" iconClass="fa-solid fa-circle-info text-info pt-2"/> :
    <ChrInfoPopover
      html
      delay={500}
      boundary="body"
      content={ props.helpText }
      placement="auto"
      container="body"
      additionalIconClass="px-1 text-info"
      trigger="click hover focus"
    />;

  return (
    <div className={`d-flex flex-row align-items-baseline ${props.className}`}>
      <span className={ className } { ...getHoverOptions(titleHoverContent, {'data-boundary': 'clippingParents'}) }>{ props.children }</span>
      { props.helpText && infoComponent }
      { props.badges && props.badges.map((badge, index) =>
        <ChrBadge key={ index } type={ badge.type } className="m-1 pt-1 border-radius-0-5-important" >
          { badge.text }
        </ChrBadge>
      )
      }
    </div>
  );
};

export default ChrMetricTitle;
